import { AfterViewInit, Component, Input, OnInit, inject } from '@angular/core';
import { FilterListComponent } from 'gung-list';
import { Assortment, AssortmentService } from 'gung-standard';

@Component({
  selector: 'colmec-filter-list',
  templateUrl: './colmec-filter-list.component.html',
  styleUrls: ['./colmec-filter-list.component.scss'],
  standalone: false
})
export class ColmecFilterListComponent<T> extends FilterListComponent<T> implements AfterViewInit, OnInit {
  private assortmentService = inject(AssortmentService);

  @Input()
  message: string;
  assortmentId: string;
  currentAssortment: Assortment;

  ngOnInit(): void {
    super.ngOnInit();
    this.route.params.subscribe(params => {
      this.assortmentService
        .getAssortment(params.assortmentId)
        .subscribe(assortment => (this.currentAssortment = assortment));
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      super.ngAfterViewInit();
    }, 0);
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  getSearchGroupCss() {
    return 'colmec-search-input';
  }
}
